import React, { useCallback, useEffect } from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import { usePriceRowContext } from '../../../price-row-context';
import { Popover, Alignment } from '@prisjakt/ui/popover';
import { BodySmallText } from '@prisjakt/ui/text/variants';
import { IUnfeaturedColumns } from '../../types';
import { StoreInfoColumn } from '../../components/store-info-column';
import * as S from '../styles';
import { StockPriceInfo } from '../../components/stock-price-info';
import { GoToStoreButton } from '../../components/go-to-store-button';

export const UnfeaturedColumns: React.FC<IUnfeaturedColumns> = props => {
  const {
    tableLinkProps,
    priceRowRef,
    showDisabledInfo,
    setShowDisabledInfo,
  } = props;
  const { offer } = usePriceRowContext();
  const { name, priceId, featured } = offer;
  const { t } = useAppContext();

  const handleOutSideClick = useCallback(
    e => {
      if (
        priceRowRef &&
        priceRowRef.current &&
        priceRowRef.current.contains(e.target)
      ) {
        return;
      }
      setShowDisabledInfo(false);
    },
    [priceRowRef, setShowDisabledInfo]
  );

  // componentWillUnmount
  useEffect(() => {
    return () => {
      window.removeEventListener('click', handleOutSideClick);
    };
  }, [handleOutSideClick]);

  // Callback for showDisabledInfo state change
  useEffect(() => {
    if (showDisabledInfo) {
      window.addEventListener('click', handleOutSideClick);
    } else {
      window.removeEventListener('click', handleOutSideClick);
    }
  }, [handleOutSideClick, showDisabledInfo]);

  return (
    <>
      <S.Link {...tableLinkProps} aria-describedby={`click-out-${priceId}`}>
        <StoreInfoColumn />
        <S.MiddleColumn>
          <S.TopMiddleRow featured={featured}>
            <S.ProductNameColumn featured={featured}>
              <S.ProductName featured={featured}>{name}</S.ProductName>
            </S.ProductNameColumn>
            <StockPriceInfo />
          </S.TopMiddleRow>
        </S.MiddleColumn>

        <S.EndColumn featured={featured}>
          <GoToStoreButton />
        </S.EndColumn>
      </S.Link>

      <Popover
        id={`click-out-${priceId}`}
        visible={Boolean(showDisabledInfo)}
        width={250}
        horizontalAlign={Alignment.Center}
        verticalAlign={Alignment.Center}
        onClose={() => setShowDisabledInfo(!showDisabledInfo)}
      >
        <BodySmallText>{t('product', 'transparency.store-info')}</BodySmallText>
      </Popover>
    </>
  );
};
